<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Manual Data Entry</h6>
                </div>

                <button
                    type="button"
                    @click="addRow"
                    class="btn b-solid btn-primary-solid cursor-pointer shadow-sm"
                >
                    Add Row
                </button>
            </div>

            <div class="p-3 sm:p-4">
                <div class="overflow-x-auto scrollbar-table">
                    <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none table-bordered" id="manualDataEntryTable">
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr>
                                <th class="px-3.5 py-4">#</th>
                                <th class="px-3.5 py-4">Order Number</th>
                                <th class="px-3.5 py-4">Customer Name</th>
                                <th class="px-3.5 py-4">Status</th>
                                <th class="px-3.5 py-4">Full Shirt</th>
                                <th class="px-3.5 py-4">Half Shirt</th>
                                <th class="px-3.5 py-4">Pant</th>
                                <th class="px-3.5 py-4">Previous Status</th>
                                <th class="px-3.5 py-4">Action</th>
                            </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr
                                class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white"
                                v-for="(row, index) in rows"
                                :key="row.uid"
                            >
                                <td class="px-3.5 py-4">{{ index + 1 }}</td>
                                <td class="px-3.5 py-4">
                                    <input
                                        type="text"
                                        v-model.trim="row.order_number"
                                        class="form-input order-input"
                                        placeholder="Order no"
                                        @keyup.enter="getOrder(row)"
                                        @change="resetRowOrder(row)"
                                    />
                                    <div class="text-xs mt-1" :class="row.error ? 'text-red-500' : 'text-gray-400'">
                                        <span v-if="row.loading">Loading...</span>
                                        <span v-else-if="row.error">{{ row.error }}</span>
                                        <span v-else-if="row.id">Press enter again to refresh</span>
                                        <span v-else>Press enter to load qty</span>
                                    </div>
                                </td>
                                <td class="px-3.5 py-4">{{ row.customer_name || '-' }}</td>
                                <td class="px-3.5 py-4">
                                        <select v-model="row.status" class="form-input status-input"  >
                                            <option value="">Status</option>
                                            <option v-for="status in statuses" :key="status" :value="status">
                                                {{ status }}
                                            </option>
                                             </select>
                                            </td>
                                <td class="px-3.5 py-4">
                                    <div class="qty-cell">
                                       
                                        <input
                                            type="number"
                                            min="0"
                                            v-model.number="row.entered_qty_full"
                                            class="qty_input"
                                            :readonly="row.original_full_shirt <= 0"
                                            @input="validate(row)"
                                        />
                                        <span class="original-qty">/ {{ row.original_full_shirt }}</span>
                                    </div>
                                </td>
                                <td class="px-3.5 py-4">
                                    <div class="qty-cell">
                                       
                                        <input
                                            type="number"
                                            min="0"
                                            v-model.number="row.entered_qty_half"
                                            class="qty_input"
                                            :readonly="row.original_half_shirt <= 0"
                                            @input="validate(row)"
                                        />
                                        <span class="original-qty">/ {{ row.original_half_shirt }}</span>
                                    </div>
                                </td>
                                <td class="px-3.5 py-4">
                                    <div class="qty-cell">
                                       
                                        <input
                                            type="number"
                                            min="0"
                                            v-model.number="row.entered_qty_pant"
                                            class="qty_input"
                                            :readonly="row.original_pant <= 0"
                                            @input="validate(row)"
                                        />
                                        <span class="original-qty">/ {{ row.original_pant }}</span>
                                    </div>
                                </td>
                                <td class="px-3.5 py-4">
                                    {{ getStatusString(row.statuses) }}
                                </td>
                                <td class="px-3.5 py-4">
                                    <button
                                        type="button"
                                        class="btn b-solid btn-danger-solid cursor-pointer"
                                        @click="removeRow(index)"
                                        :disabled="rows.length <= 1"
                                    >
                                        Remove
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="flex flex-wrap justify-between items-center gap-4 mt-7">
                    <button
                        type="button"
                        @click="addRow"
                        class="btn b-solid btn-primary-solid cursor-pointer shadow-sm"
                    >
                        Add Row
                    </button>

                    <button
                        type="button"
                        @click="saveDataEntry"
                        class="btn b-solid btn-primary-solid cursor-pointer shadow-sm"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- End Main Content -->
</template>

<script>
import axios from 'axios';

function createManualRow() {
    return {
        uid: Date.now() + Math.random(),
        id: '',
        custid: '',
        order_number: '',
        customer_name: '',
        original_full_shirt: 0,
        original_half_shirt: 0,
        original_pant: 0,
        entered_qty_full: 0,
        entered_qty_half: 0,
        entered_qty_pant: 0,
        status_full: '',
        status_half: '',
        status_pant: '',
        statuses: [],
        loading: false,
        error: '',
        loaded_order_number: '',
    };
}

function createManualRows(count) {
    const rows = [];

    for (let i = 0; i < count; i++) {
        rows.push(createManualRow());
    }

    return rows;
}

export default {
    name: 'OrderDataEntry',
    data() {
        return {
            rows: createManualRows(30),
            statuses: [
                'Washing',
                'Cutting',
                'Stitching',
                'ironing',
                'packing',
                'delivered',
            ],
        };
    },
    methods: {
        createRows(count) {
            return createManualRows(count);
        },

        createRow() {
            return createManualRow();
        },

        addRow() {
            this.rows.push(this.createRow());
        },

        removeRow(index) {
            if (this.rows.length <= 1) {
                return;
            }

            this.rows.splice(index, 1);
        },

        resetRowOrder(row) {
            if (row.loaded_order_number == row.order_number) {
                return;
            }

            row.id = '';
            row.custid = '';
            row.customer_name = '';
            row.original_full_shirt = 0;
            row.original_half_shirt = 0;
            row.original_pant = 0;
            row.entered_qty_full = 0;
            row.entered_qty_half = 0;
            row.entered_qty_pant = 0;
            row.status_full = '';
            row.status_half = '';
            row.status_pant = '';
            row.statuses = [];
            row.error = '';
            row.loaded_order_number = '';
        },

        getOrder(row) {
            const self = this;

            if (!row.order_number) {
                row.error = 'Enter order number';
                return;
            }

            row.loading = true;
            row.error = '';

            axios.post('getDataEntryOrderByNumber', { order_number: row.order_number })
                .then(function (response) {
                    const data = response.data || {};
                    const order = data.order || data.orderDetails || data.item || {};

                    if (!order.invoiceno) {
                        self.resetRowOrder(row);
                        row.order_number = data.invoiceno || row.order_number;
                        row.error = data.msg || 'Order not found';
                        return;
                    }

                    row.id = order.id || '';
                    row.custid = order.custid || '';
                    row.order_number = order.order_number || row.order_number;
                    row.loaded_order_number = row.order_number;
                    row.customer_name = order.customer_name || '';
                    row.original_full_shirt = Number(order.original_full_shirt || order.fullshirt || 0);
                    row.original_half_shirt = Number(order.original_half_shirt || order.halfshirt || 0);
                    row.original_pant = Number(order.original_pant || order.pant || 0);
                    row.entered_qty_full = 0;
                    row.entered_qty_half = 0;
                    row.entered_qty_pant = 0;
                    row.status_full = '';
                    row.status_half = '';
                    row.status_pant = '';
                    row.statuses = order.statuses || [];
                })
                .catch(function (error) {
                    console.log('Error while loading order: ' + error);
                    row.error = 'Error loading order';
                })
                .then(function () {
                    row.loading = false;
                });
        },

        getStatusString(statuses) {
            if (!statuses || statuses.length == 0) {
                return '-';
            }

            return statuses.map(status => {
                let qty = [];

                if (parseInt(status.full) > 0) {
                    qty.push(`F:${status.full}`);
                }

                if (parseInt(status.half) > 0) {
                    qty.push(`H:${status.half}`);
                }

                if (parseInt(status.pant) > 0) {
                    qty.push(`P:${status.pant}`);
                }

                return `${status.status} (${qty.join(', ')}) ${status.iddate || ''}`;
            }).join(' | ');
        },

        validate(row) {
            row.entered_qty_full = this.normalizeQty(row.entered_qty_full, row.original_full_shirt);
            row.entered_qty_half = this.normalizeQty(row.entered_qty_half, row.original_half_shirt);
            row.entered_qty_pant = this.normalizeQty(row.entered_qty_pant, row.original_pant);
        },

        normalizeQty(value, max) {
            const qty = Number(value || 0);
            const limit = Number(max || 0);

            if (qty < 0) {
                return 0;
            }

            if (qty > limit) {
                return limit;
            }

            return qty;
        },

        hasQtyWithoutStatus(row) {
            return (row.entered_qty_full > 0 && !row.status_full)
                || (row.entered_qty_half > 0 && !row.status_half)
                || (row.entered_qty_pant > 0 && !row.status_pant);
        },

        hasStatusWithoutQty(row) {
            return (row.status_full && row.entered_qty_full <= 0)
                || (row.status_half && row.entered_qty_half <= 0)
                || (row.status_pant && row.entered_qty_pant <= 0);
        },

        saveDataEntry() {
            const self = this;
            const selectedRows = this.rows.filter(function (row) {
                return row.id && (
                    row.entered_qty_full > 0
                    || row.entered_qty_half > 0
                    || row.entered_qty_pant > 0
                    || row.status
                );
            });

            if (selectedRows.length == 0) {
                this.$swal('Please enter at least one order qty');
                return;
            }

     

          
            const payload = {
                orders: selectedRows.map(function (row) {
                    return {
                        id: row.id,
                        order_number: row.order_number,
                        custid: row.custid,
                        fullqty: row.entered_qty_full,
                        halfqty: row.entered_qty_half,
                        pantqty: row.entered_qty_pant,
                        status: row.status,
                    };
                }),
            };

            axios.post('saveManualDataEntry', payload)
                .then(function (response) {
                    const msg = response.data.msg || 'Data entry saved successfully';
                    const isSuccess = response.data.status;

                    self.$swal(msg);

                    if (isSuccess == 1) {
                        self.rows = self.createRows(30);
                    }
                })
                .catch(function (error) {
                    console.log('Error while saving manual data entry: ' + error);
                    self.$swal('Error while saving manual data entry');
                });
        },
    },
};
</script>

<style scoped>
    .order-input {
        min-width: 150px;
    }

    .qty-cell {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .status-input {
        min-width: 120px;
    }

    .qty_input {
        border: 1px solid black;
        width: 60px;
        padding: 4px;
        border-radius: 3px;
    }

    .original-qty {
        min-width: 28px;
        color: #6b7280;
    }
</style>
